// extracted by mini-css-extract-plugin
export default {"image":"ErrorMessage_image__11qcR"};